import { v4 as uuidv4 } from 'uuid';
import { ConnectionSettingsF3busView } from '../view/ConnectionSettingsF3busView';
import { ConnectionSettingsF3busPlugin } from '../pluginSettings/ConnectionSettingsF3busPlugin';

export const ConnectionSettingsF3busTab = (): ITab => {

    return {
        id: uuidv4(),
        title: 'Настройка соединения F3bus',
        plugin: 'connection_settings_f3bus_plugin',
        view: {
            content: ConnectionSettingsF3busPlugin ? <ConnectionSettingsF3busView plugin={ConnectionSettingsF3busPlugin} /> : <p> Справочник не настроен </p>
        }
    }
}